import {ISignalInfo, ITelematics} from '@signal/asp-data-commons';

class Alert {
  title: string;
  message: string;
  code?:string;
  type?: string;
  remedyAvailable?: string;
}

export class Telematics {
  engineOilLevelStatus: string;
  engineOilImageURL: any;
  engineOilLevelStatusHover = 'service.engineOilLevel:';
  milesToEmptyDescription: string;
  milesToEmptyDescriptionHover = 'service.currentMileage:';
  smartKeyBatteryDegradationStatus: string;
  smartKeyBatteryDegradationStatusToShow: string;
  smartKeyImageURL: any;
  smartKeyBatteryDegradationStatusHover = 'service.smartKeyBatteryDegradationStatus:';
  fuel: string;
  fuelHover = 'service.fuelLevel:';
  alerts: Alert[] = [];
  protectionProduct: ISignalInfo;
  mileage:string = '';
  tirePressureStatus:string = '';
  tirePressureStatusHover = 'service.tirePressureStatus:';
  static notAvailable = '(Not available)';

  constructor(engineOilLevelStatus: number,
              engineOilImageURL: any,
              milesToEmptyDescription: string,
              milesToEmptyDescriptionHover: string = '',
              smartKeyBatteryDegradationStatus: string,
              smartKeyImageURL: any,
              smartKeyBatteryDegradationStatusHover: string = '',
              fuel: string = '',
              mileage:string = '',
              tirePressureStatus:string = '',
              tirePressureStatusHover:string = '') {

    this.engineOilLevelStatus = `${engineOilLevelStatus || '--'}`;
    this.engineOilImageURL = engineOilImageURL;
    this.engineOilLevelStatusHover += this.engineOilLevelStatus;
    const find = 'undefined';
    const re = new RegExp(find, 'g')
    const milesText = milesToEmptyDescription?.replace(re, '')?.trim() || '--';
    this.milesToEmptyDescription = milesText === ''? '--' : milesText;
    const milesDescriptionHover = milesToEmptyDescriptionHover?.replace(re, '')?.trim() || '--';
    this.milesToEmptyDescriptionHover += milesDescriptionHover;
    this.mileage = mileage?.replace(re, '')?.trim() || '';


    this.smartKeyBatteryDegradationStatus = smartKeyBatteryDegradationStatus;
    this.smartKeyBatteryDegradationStatusToShow = Telematics.getHoverTextFromStatus(this.smartKeyBatteryDegradationStatus);
    this.smartKeyImageURL = smartKeyImageURL;
    this.smartKeyBatteryDegradationStatusHover += (smartKeyBatteryDegradationStatusHover === undefined ||
       smartKeyBatteryDegradationStatusHover?.length=== 0 )?
    Telematics.notAvailable : smartKeyBatteryDegradationStatusHover;

    const fuelText = fuel?.replace(re, '')?.trim() || '--'
    this.fuel =  fuelText === ''? '--' : fuelText;;
    this.fuelHover += fuelText;
    
    this.tirePressureStatus = tirePressureStatus;
    this.tirePressureStatusHover += tirePressureStatus;
  }

  static getHoverTextFromStatusImage(status: string) {
    if (status && status?.toUpperCase().includes('GREEN')) {
      return 'Ok';
    } else if (status && status?.toUpperCase().includes('RED')) {
      return 'Bad';
    } else {
      return '--';
    }
  }
  static getHoverTextFromStatus(status: string) {
    if (status && status === '3') {
      return 'Ok';
    } else if (status && status === '2') {
      return 'Bad';
    } else {
      return '--';
    }
  }

  static getTelematics(telematics: ITelematics) {
    var telematicsObj = this.getDefaultTelematics();
    const vehicleStatus = telematics?.vehicleHealthStatus;
    if(telematics.vehicleHealthStatus){
    telematicsObj = new Telematics(
      vehicleStatus.qtyOfEngOilStatus,
      vehicleStatus.qtyOfEngOilIcon,
      `${vehicleStatus.mileage} ${vehicleStatus.mileageUnit}`,
      `${vehicleStatus.mileage} ${vehicleStatus.mileageUnit}`,
      vehicleStatus.smartKeyBatStatus,
      vehicleStatus.smartKeyBatIcon,
      vehicleStatus.smartKeyBatDesc,
      `${vehicleStatus.fuel} ${vehicleStatus.fuelUnit}`,
      `${vehicleStatus.mileage}`
    );
  }

    // Alerts from SSC
    const alerts : Alert[] = [];
    // Generated by Copilot- Start
    const remedyAvailable = 'Remedy Available';
    const sonarViolationFix = telematics?.sscPayload?.specialServiceCampaigns?.forEach(ssc => {
      const description = ssc.remedyAvailable === remedyAvailable
        ? ssc.remedyDescription
        : (ssc.safetyRiskDescription || ssc.remedyDescription);
      alerts.push({
        title: ssc.sscDescription || 'service.titleNotAvailable',
        code: ssc.sscCode,
        message: `${description || 'service.descriptionNotAvailable'}`,
        remedyAvailable: ssc.remedyAvailable
      })
    });
    // Generated by Copilot- End

    // Alerts from vehicle health status
    const sonarViolationFix1 = vehicleStatus?.warningsList?.forEach(warning => {
      alerts.push({
        title: warning.desc || 'service.titleNotAvailable',
        code: warning.code,
        message: `${warning.ownersManual || 'service.descriptionNotAvailable'}`,
      })
    });
    telematicsObj.tirePressureStatus = getTirePressureStatus(vehicleStatus?.warningsList).status
    telematicsObj.tirePressureStatusHover = 'service.tirePressureStatus:'+ getTirePressureStatus(vehicleStatus?.warningsList).message;
    telematicsObj.alerts = alerts;
    telematicsObj.protectionProduct = telematics.protectionProducts;

    return telematicsObj;
  }

  static getDefaultTelematics() {
    return new Telematics(
      undefined,
      undefined,
      '--',
      Telematics.notAvailable,
      '--',
      undefined,
      Telematics.notAvailable,
      '--',
      '',
      '--'
    );
  }

  getIssuesCount(): number {
    return this.alerts ? this.alerts.length : 0;
  }

  issueExists(): boolean {
    return this.getIssuesCount() > 0;
  }

  noIssueExists(): boolean {
    return this.getIssuesCount() === 0;
  }

  getIssueCountDesc(): string {
    const issueCount = this.getIssuesCount();
    const issueDescStr = issueCount === 0 ? 'no' : issueCount;
    return issueDescStr + ' Alert' + (issueCount === 1 ? '' : 's');
  }
}
function getTirePressureStatus(warningsList):{status:string,message:string}{
  if(warningsList === undefined ||(warningsList && warningsList?.length=== 0)){
    return {status:'--',message: Telematics.notAvailable};
  }
  else{
    const warninglist=warningsList?.find(warning =>{ return warning.code?.toUpperCase() === 'TIRW' ||  warning.code?.toUpperCase() === 'TILW'})
    if((warninglist))
    {
      return {status:'Bad',message:'Bad'};
    }else{
      return {status: 'Ok',message: 'Good'};
    }
  }
}
